import React from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'presentation/hooks/use-stores'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { ApiRepository } from 'repository/api-repository'
import { ActiveSearchRepository } from 'repository/repositories/active-search/active-search-repository'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { RemoteLoadActiveSearchStatistics } from 'service/usecases/load-active-search-statistics/remote-load-active-search-statistics'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import ActiveSearchLayout from 'presentation/hospital/layouts/ActiveSearch'

const ActiveSearchDashboard = observer(() => {
  const currentHospital = useStores().currentHospital.actualHospital

  // Jogar essas novas rotas dentro do service
  const apiClient = new ApiClientImplementation()
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(apiClient)
  )
  const activeSearchRepository = new ActiveSearchRepository(apiRepository)
  const loadActiveSearchStatistics = new RemoteLoadActiveSearchStatistics(
    activeSearchRepository
  )

  return (
    <ContainerNew>
      <ActiveSearchLayout
        loadActiveSearchStatistics={loadActiveSearchStatistics}
        currentHospitalId={currentHospital!.hospital_id}
      />
    </ContainerNew>
  )
})

export default ActiveSearchDashboard
